var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "allocation-options" }, [
    _c(
      "div",
      {
        staticClass: "allocation-card",
        class: { selected: _vm.allocationMode === 1 },
        on: {
          click: function ($event) {
            return _vm.handleChange(1)
          },
        },
      },
      [
        _vm.allocationMode === 1
          ? _c(
              "div",
              { staticClass: "card-check" },
              [
                _c("a-icon", {
                  attrs: { type: "check-circle", theme: "filled" },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "card-icon sequential" }, [_vm._v("🎯")]),
        _c("h4", { staticClass: "card-title" }, [
          _vm._v(_vm._s(_vm.$t("SequentialExecution"))),
        ]),
        _c("p", { staticClass: "card-desc" }, [
          _vm._v(_vm._s(_vm.$t("SequentialExecutionDesc"))),
        ]),
        _c("div", { staticClass: "how-it-works" }, [
          _c("span", { staticClass: "works-label" }, [
            _vm._v(_vm._s(_vm.$t("HowItWorks")) + ":"),
          ]),
          _c("div", { staticClass: "campaign-flow" }, [
            _c("div", { staticClass: "flow-item active" }, [
              _c("div", { staticClass: "flow-name" }, [
                _vm._v(_vm._s(_vm.$t("campaignA"))),
              ]),
              _c("div", { staticClass: "flow-limit" }, [
                _vm._v(_vm._s(_vm.dailyLimit) + _vm._s(_vm.$t("perDay"))),
              ]),
              _c("div", { staticClass: "flow-status" }, [
                _vm._v(_vm._s(_vm.$t("running"))),
              ]),
            ]),
            _c("span", { staticClass: "flow-arrow" }, [
              _vm._v(_vm._s(_vm.$t("then"))),
            ]),
            _c("div", { staticClass: "flow-item waiting" }, [
              _c("div", { staticClass: "flow-name" }, [
                _vm._v(_vm._s(_vm.$t("campaignB"))),
              ]),
              _c("div", { staticClass: "flow-limit" }, [
                _vm._v(_vm._s(_vm.dailyLimit) + _vm._s(_vm.$t("perDay"))),
              ]),
              _c("div", { staticClass: "flow-status" }, [
                _vm._v(_vm._s(_vm.$t("waiting"))),
              ]),
            ]),
            _c("span", { staticClass: "flow-arrow" }, [
              _vm._v(_vm._s(_vm.$t("then"))),
            ]),
            _c("div", { staticClass: "flow-item waiting" }, [
              _c("div", { staticClass: "flow-name" }, [
                _vm._v(_vm._s(_vm.$t("campaignC"))),
              ]),
              _c("div", { staticClass: "flow-limit" }, [
                _vm._v(_vm._s(_vm.dailyLimit) + _vm._s(_vm.$t("perDay"))),
              ]),
              _c("div", { staticClass: "flow-status" }, [
                _vm._v(_vm._s(_vm.$t("waiting"))),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "warning-tip" },
          [
            _c("a-icon", { attrs: { type: "exclamation-circle" } }),
            _vm._v(" " + _vm._s(_vm.$t("SequentialWarning")) + " "),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "allocation-card",
        class: { selected: _vm.allocationMode === 2 },
        on: {
          click: function ($event) {
            return _vm.handleChange(2)
          },
        },
      },
      [
        _vm.allocationMode === 2
          ? _c(
              "div",
              { staticClass: "card-check" },
              [
                _c("a-icon", {
                  attrs: { type: "check-circle", theme: "filled" },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "card-icon equal" }, [_vm._v("⚖️")]),
        _c("h4", { staticClass: "card-title" }, [
          _vm._v(_vm._s(_vm.$t("EqualDistribution"))),
        ]),
        _c("p", { staticClass: "card-desc" }, [
          _vm._v(_vm._s(_vm.$t("EqualDistributionDesc"))),
        ]),
        _c("div", { staticClass: "how-it-works" }, [
          _c("span", { staticClass: "works-label" }, [
            _vm._v(_vm._s(_vm.$t("HowItWorks")) + ":"),
          ]),
          _c("div", { staticClass: "equal-stats" }, [
            _c("div", { staticClass: "equal-row" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("DailyLimit")) + ":")]),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.dailyLimit) + " " + _vm._s(_vm.$t("requests"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "equal-row" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("ActiveCampaigns")) + ":")]),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.activeCampaignsCount) +
                    " " +
                    _vm._s(_vm.$t("campaigns"))
                ),
              ]),
            ]),
            _c("div", { staticClass: "equal-row highlight" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("EachCampaignGets")) + ":")]),
              _c("strong", { staticClass: "highlight-text" }, [
                _vm._v(
                  "~" +
                    _vm._s(
                      _vm.activeCampaignsCount
                        ? Math.floor(_vm.dailyLimit / _vm.activeCampaignsCount)
                        : _vm.dailyLimit
                    ) +
                    " " +
                    _vm._s(_vm.$t("requestsPerDay"))
                ),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "info-tip" }, [
          _c("span", [_vm._v("💡")]),
          _vm._v(" " + _vm._s(_vm.$t("EqualInfo")) + " "),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }